<template>
<div>
    <div class="breadcrumbs" id="breadcrumbs">
        <router-link class="breadcrumb-link" to="/dashboard/">Bookblock HUB Dashboard</router-link>
    </div>
    <h3>Welcome To Your Bookblock HUB Dashboard.</h3>

    <notification v-if="!demo.isDemo && team.plan=='pro'" type="gift_registrations"></notification>
    <notification v-if="!demo.isDemo && team.plan=='pro'" type="allocation"></notification>
    <notification v-if="!demo.isDemo && team.plan=='pro'" type="balance"></notification>
    <notification v-if="!demo.isDemo" type="team_config"></notification>

    <div id="dashboard-stats">
      <div class="stats-box" id="stats-balance">
        <div class="stats-value loadable" :class="{ loaded: loadedActions.includes('fetchTeam') }"><div class="value-loader"></div><div class="value">{{ team.total_available | toCurrency }}</div></div>
        <div class="stats-sub">Available Team Balance</div>
        <div class="stats-sub" v-if="team.total_available!=team.balance" style="font-size: 14px; font-weight: 100;">(<b>{{ team.balance | toCurrency }}</b> in own resouces)</div>
        <div class="stats-actions">
          <a class="ws-button ws-button-white full-width" href="#" @click.prevent="$router.push('/billing')">View Details / Top Up</a>
        </div>
      </div>

      <div class="stats-box" id="stats-gifting">
        <div class="stats-value loadable" :class="{ loaded: loadedActions.includes('fetchGiftBoxCampaigns') }" ><div class="value-loader"></div><div class="value">{{ stats.gifting_campaigns}}</div></div>
        <div class="stats-sub">Bookblock HUB Gifting Campaigns</div>
        <div class="stats-actions">
          <a class="ws-button ws-button-white short" href="#" @click.prevent="$router.push('/campaigns')">View</a><div class="ws-button ws-button-white long" @click="requestNewCampaign('physical')">Add Campaign</div>
        </div>
      </div>

      <div class="stats-box" id="stats-voucher">
        <div class="stats-value loadable" :class="{ loaded: loadedActions.includes('fetchGiftBoxCampaigns') }" ><div class="value-loader"></div><div class="value">{{ stats.voucher_campaigns }}</div></div>
        <div class="stats-sub">Bookblock HUB Voucher Campaigns</div>
        <div class="stats-actions">
            <a class="ws-button ws-button-white short" href="#" @click.prevent="$router.push('/campaigns')">View</a><div class="ws-button ws-button-white long" @click="requestNewCampaign('voucher')">Add Campaign</div>
        </div>
      </div>
      <!--
      <div class="stats-box" id="stats-se">
        <div class="stats-value loadable" :class="{ loaded: loadedActions.includes('fetchSingleEventCampaigns') }"><div class="value-loader"></div><div class="value">{{ indexSECampains.meta ? indexSECampains.meta.total : 0 }}</div></div>
        <div class="stats-sub">single event campaigns</div>
        <div class="stats-actions">
          <a class="ws-button ws-button-white short" href="/single-event-campaigns/">View</a><a class="ws-button ws-button-white long" href="/single-event-campaigns/new">Add Campaign</a>
        </div>
      </div>
      -->

    </div>

    <div id="dashboard-products" class="stats-box">
      <div id="dashboard-products-left">
        <div class="stats-value loadable" :class="{ loaded: loadedActions.includes('fetchProducts') }"><div class="value-loader"></div><div class="value">{{ indexProducts.data ? indexProducts.data.length : 0 }}</div></div>
        <div class="stats-sub">team products</div>
        <div class="stats-actions">
          <a class="ws-button full-width" href="#" @click.prevent="$router.push('/campaigns/corporate-products')">View All Products</a>
          <a class="ws-button ws-button-main full-width" href="#" @click.prevent="$router.push('/campaigns/corporate-products/requests')">Product Requests</a>
        </div>
      </div>
      <div id="dashboard-products-right">
        <div id="gift-registrations-chart-control" class="stats-value loadable" :class="{ loaded: loadedActions.includes('fetchGiftBoxRegistrationStats') }">
          <div class="value-loader"></div>
          <div class="value">
            <div id="gift-registrations-chart-total" >{{ registrationStatsTotal() }}</div>
            gift registrations in the last <b>30 days</b>.
          </div>
        </div>
        <div id="gift-registrations-chart">
          <bar-chart v-if="registrationsChart.loaded" :width="300" :height="300" :chart-data="registrationsChart.data" :options="registrationsChart.options"/>
        </div>
      </div>
    </div>
    
    <gift-box-campaigns-edit-modal v-if="modals.editGiftBoxCampaign" :reward-type="newCampaignType" type="create" tab="campaign"></gift-box-campaigns-edit-modal>

</div>
</template>

<script>
import BarChart from "@/components/charts/BarChart";
import GiftBoxCampaignsEditModal from '@/pages/gift-box-campaigns/GiftBoxCampaignsEditModal';

export default {
    name: "DashboardPage",
    components: { BarChart, GiftBoxCampaignsEditModal },
    data: () => ({
        dispatch: [],
        demoTotal: 0,
        newCampaignType: 'physical',
        registrationsChart: {loaded: false, data: null, options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              xAxes: [{
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1,
                gridLines: {
                    color: "rgba(0, 0, 0, 0)",
                },
              }],
              yAxes: [{
                stacked: true,
                ticks: {
                    beginAtZero: true,
                    callback: function (value) { if (Number.isInteger(value)) { return value; } },
                    //stepSize: 1
                }
              }]
            },
            tooltips: {
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              borderColor: '#628aba',
              borderWidth: 1,
              xPadding: 15,
              yPadding: 12,
              titleFontColor: "#333",
              titleSpacing: 4,
              bodyFontColor: "#333",
              displayColors: false,
            },
          }},
      stats: {gifting_campaigns: 0, voucher_campaigns: 0},
    }),
    methods: {
      async fetchData() {
        this.dispatch.push(this.dispatchWaitAndNotify('fetchTeam', null, false, true));
        this.dispatch.push(this.dispatchWaitAndNotify('fetchGiftBoxCampaigns', null, true, true));
        this.dispatch.push(this.dispatchWaitAndNotify('fetchSingleEventCampaigns', null, true, true));
        this.dispatch.push(this.dispatchWaitAndNotify('fetchProducts', null, true, true));
        this.dispatch.push(this.dispatchWaitAndNotify('fetchGiftBoxRegistrationStats', null, true, true));
        await Promise.all(this.dispatch);

        for (var i=0; i<this.indexGiftCampains.data.length; i++) {
            if (['physical','mixed'].includes(this.indexGiftCampains.data[i].reward_type)) this.stats.gifting_campaigns++;
            if (['voucher','mixed'].includes(this.indexGiftCampains.data[i].reward_type)) this.stats.voucher_campaigns++;
        }
        this.renderRegistrationsChart();
      },
            
      requestNewCampaign(type) {
          this.newCampaignType = type;
          this.modals.editGiftBoxCampaign = true;
      },
      renderRegistrationsChart() {
        var days = this.getDaysArray(new Date(this.registrationStats.startDate),new Date(this.registrationStats.endDate));
        var dataSets = [];
        var backgroundColors = ['#1e4b7c','#3274b5','#48a0f8','#73bffa','#73d8f9','#90c2cd'];
        var currentColor = 0;

        for (var i=0;i<this.registrationStats.data.length;i++) {
          let queryData = this.registrationStats.data[i];
          let dailyData = [];
          for (var j=0;j<days.length;j++) {
            let dayData = 0;
            
            if (this.demo.isDemo) {
                dayData = 5 - Math.floor(Math.random() * 10);
                if (dayData < 0) dayData = 0;
                this.demoTotal += dayData;
            } else if (days[j] in queryData.dates) dayData = queryData.dates[days[j]];
            dailyData.push(dayData);
          }
          dataSets.push({
            label: queryData.name,
            backgroundColor: queryData.name=='Marketplace'?'#cd9090':backgroundColors[currentColor++],
            data: dailyData,
          });
        }
        this.registrationsChart.data = {
          labels: days,
          datasets: dataSets,
        }
        this.registrationsChart.loaded = true;
      },
      getDaysArray(start, end) {
          for(var arr=[],dt=new Date(start); dt<=end; dt.setDate(dt.getDate()+1)) {
            arr.push(dt.getDate()+'/'+(dt.getMonth()+1));
          }
          return arr;
      },
      registrationStatsTotal() {
          if (this.demo.isDemo) return this.demoTotal;
          let total = 0;
          if (typeof this.registrationStats.data == 'object') for (let i = 0; i < this.registrationStats.data.length; i++) total+=this.registrationStats.data[i].registrations;
          return total;
      },
    },
    mounted() {
        this.fetchData();
    },
    computed: {
        indexGiftCampains () {
          return this.$store.state.giftBoxCampaign.index;
        },
        indexSECampains () {
          return this.$store.state.singleEventCampaign.index;
        },
        indexProducts() {
            return this.$store.state.product.index;
        },
        registrationStats() {
            return this.$store.state.giftBoxCampaign.registrationStats;
        },
        team() {
            return this.$store.state.team.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
        demo() {
            return this.$store.state.demo;
        }
    },
}
</script>
